export default {
  USER_REPORT_REQUEST: 'APP/USER_REPORT/USER_REPORT_REQUEST',
  USER_REPORT_SUCCESS: 'APP/USER_REPORT/USER_REPORT_SUCCESS',
  USER_REPORT_ERROR: 'APP/USER_REPORT/USER_REPORT_ERROR',
};
